
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/orthopedics",
      function () {
        return require("private-next-pages/orthopedics.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/orthopedics"])
      });
    }
  